var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-modal',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" СМС-уведомление ")]},proxy:true}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{attrs:{"src":require('../../assets/img/sms-preview.png')}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }